<template>

    <Grid>

        <Column v-if="title" :span="[ 2, stacked ? 4 : 2 ]" :push="[ 0, stacked ? 1 : 0 ]">

            <Paragraph class="title-list__title" v-html="title"/>

        </Column>

        <Column v-for="(item, idx) of items" :key="`${item}.${idx}`"
                :span="[ 2, 2 ]"
                :push="stacked ? [ 0, idx === 0 ? 1 : 0 ] : [ 0, title ? 0 : idx === 0 ? 1 : 0 ]"
                :class="[ idx === 1 ? 'sm:mt-0' : title ? 'sm:mt-6' : 'sm:mt-0', { 'mt-12': stacked } ]">

            <template v-for="(tech, id) of item" :key="id">

                <Anchor class="title-list__item --anchor" v-if="careers" :route="{ name: Route.CareersSingle, params: { slug: tech?.slug ?? '' } }">
                    {{ tech.title }}
                </Anchor>

                <Anchor
                    class="title-list__item --anchor"
                    v-else-if="(typeof(tech) === 'object' && tech.type === 'link' )"
                    :route="{ name: Route.Services, params: { slug: tech?.entry?.slug ?? '' } }">
                    {{ tech.label }}
                </Anchor>

                <Paragraph v-else-if="(typeof(tech) === 'object' && tech.type === 'text' )" class="title-list__item" no-margin v-html="tech.text"/>

                <Paragraph v-else class="title-list__item" no-margin v-html="tech"/>

            </template>

        </Column>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent, PropType } from 'vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Anchor from './Anchor.vue'
    import Paragraph from './Paragraph.vue'
    import { Route } from '../enums/Route'
    import { CaseListInterface } from '../Interfaces/CaseListInterface'
    import chunk from 'lodash.chunk'

    export default defineComponent({
        name: 'TitleAndList',
        components: {
            Anchor,
            Paragraph,
            Column,
            Grid
        },
        props: {
            title: { type: String, required: false },
            list: { type: Array as PropType<string[] | CaseListInterface[]>, required: true },
            index: { type: Number, default: 0 },
            careers: { type: Boolean, default: false },
            stacked: { type: Boolean, default: false }
        },
        setup(props) {

            return {
                Route,
                items: chunk(props.list, Math.ceil(props.list.length / 2))
            }

        }
    })

</script>

<style lang="scss">

    @include component(title-list) {

        @include part(title) {

            @apply pl-6 leading-6 font-mabry-pro;

            font-size: 20px;
            border-left: 1px solid #ccc;

        }

        @include part(item) {

            @apply py-5 text-base font-normal;

            margin-top: 0;

            @screen md {

                &:first-child {

                    padding-top: 0;

                }

            }

            @include option(anchor) {

                transition: color 250ms ease;

                &:hover {

                    @apply text-pink-400;

                }

            }

        }

    }

</style>
